const { debounce } = window.BAO.Utils

class OverflowArrows extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.updateArrowVisibility()
  }

  setupListeners () {
    this.handleLeft = this.handleLeft.bind(this)
    this.handleRight = this.handleRight.bind(this)
    this.updateArrowVisibility = this.updateArrowVisibility.bind(this)

    this.els.left.elements.forEach((leftEl) => {
      this.listeners.add(leftEl, 'click', this.handleLeft)
    })

    this.els.right.elements.forEach((rightEl) => {
      this.listeners.add(rightEl, 'click', this.handleRight)
    })

    this.listeners.add(
      this.els.items.element,
      'scroll',
      this.updateArrowVisibility,
    )

    this.onResize = this.onResize.bind(this)
    this.debouncedResize = debounce((event) => {
      this.onResize(event)
    }, 240)
    this.listeners.add(window, 'resize', this.debouncedResize)
  }

  onResize () {
    this.updateArrowVisibility()
  }

  handleLeft () {
    this.els.items.element.scrollBy({ left: -200, behavior: 'smooth' })
  }

  handleRight () {
    this.els.items.element.scrollBy({ left: 200, behavior: 'smooth' })
  }

  updateArrowVisibility () {
    const isAtStart = this.els.items.element.scrollLeft <= 0
    const isAtEnd =
      Math.ceil(
        this.els.items.element.scrollLeft + this.els.items.element.clientWidth,
      ) >=
      this.els.items.element.scrollWidth - 1

    this.els.left.element.setAttribute(
      'aria-hidden',
      isAtStart ? 'true' : 'false',
    )
    this.els.right.element.setAttribute(
      'aria-hidden',
      isAtEnd ? 'true' : 'false',
    )

    this.els.items.element.classList.toggle(
      'prd-MadeToOrderFilters_Items-atStart',
      isAtStart,
    )
    this.els.items.element.classList.toggle(
      'prd-MadeToOrderFilters_Items-atEnd',
      isAtEnd,
    )
  }
}

if (!customElements.get('overflow-arrows')) {
  customElements.define('overflow-arrows', OverflowArrows)
}
